import { AfterViewInit, Directive, ElementRef, HostListener, Optional, Self } from '@angular/core';
import { AbstractControl, NgControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function mustBeZeroOrMore(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return { required: true };
    }

    if (typeof value !== 'number' || isNaN(value)) {
      return { number: true };
    }

    return value < 0 ? { minimum: 0 } : null;
  };
}

@Directive({
  selector: 'input[type=number][ngModel], input[type=number][formControlName], input[type=number][formControl]',
  standalone: true,
})
export class MustBeZeroOrMoreDirective implements AfterViewInit {
  constructor(
    private readonly elementRef: ElementRef<HTMLInputElement>,
    @Optional() @Self() private readonly ngControl?: NgControl,
  ) {}

  ngAfterViewInit(): void {
    queueMicrotask(() => this.normalizeValue());
  }

  @HostListener('blur')
  onBlur(): void {
    this.normalizeValue();
  }

  private normalizeValue(): void {
    const input = this.elementRef.nativeElement;
    const rawValue = input.value;

    if (rawValue === '') {
      input.value = '0';
      this.ngControl?.control?.setValue(0);
      return;
    }

    const parsed = Number(rawValue);
    if (!Number.isFinite(parsed)) {
      input.value = '0';
      this.ngControl?.control?.setValue(0);
      return;
    }

    if (parsed < 0) {
      input.value = '0';
      this.ngControl?.control?.setValue(0);
    }
  }
}
